import React from 'react';
import { connect } from 'react-redux';
import updateBreakpoint from '../action/updateBreakpoint';

const mapStateToProps = state =>({
  windowWidth: state.events.windowSize.width,
  breakpoint: state.events.breakpoint,
});

@connect(mapStateToProps)
export default class Breakpoint extends React.PureComponent {
  componentDidMount() {
    this.findcurrentBreakpoint();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.windowWidth !== this.props.windowWidth) {
      this.findcurrentBreakpoint();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  findcurrentBreakpoint() {
    setTimeout(() => {
      let breakpoint = 1;

      for (const bp in this.refs) {
        if (window.getComputedStyle(this.refs[bp], null).getPropertyValue('display') === 'none') {
          breakpoint++;
        } else {
          break;
        }
      }

      if (this.props.breakpoint !== breakpoint) {
        this.props.dispatch(updateBreakpoint(breakpoint));
      }
    });
  }

  render() {
    return (
      <div className="breakpoints">
        <div className="hidden-sm-up" ref="sm"></div>
        <div className="hidden-md-up" ref="md"></div>
        <div className="hidden-lg-up" ref="lg"></div>
        <div className="hidden-xl-up" ref="xl"></div>
        <div className="hidden-xxl-up" ref="xxl"></div>
      </div>
    );
  }
}

Breakpoint.propTypes = {
  windowWidth: React.PropTypes.number,
  breakpoint: React.PropTypes.number,
  dispatch: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/component/Breakpoint.jsx